/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useTranslation } from 'react-i18next'


const NotificationTypeHeader = ({ type }) => {
    const headerColor = type === 'NEW' ? '#21BA45' : '#DB2828';
    const [t] = useTranslation()

    return (
      <div
        css={css`
            position: relative;
            width: 100%;
            height: 1.5rem;
            background-color: ${headerColor};
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            overflow: hidden;
        `}
      >
          <span
            css={css`
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
                font-weight: 600;
                z-index: 1;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            `}
          >
            {type === 'NEW' ?
              t('order.notification.new_order') :
              t('order.notification.order_cancelled')}
        </span>
      </div>
    )
}

export { NotificationTypeHeader }
